import React from 'react';
import * as Styles from './pricing.styled';
import { truncatedZeroPencePrice } from '@at/formatter-utils/lib/number-utils/number.utils';
export var PricingLease = function (_a) {
    var priceMonthly = _a.priceMonthly, priceUpfront = _a.priceUpfront;
    return (React.createElement(React.Fragment, null,
        priceMonthly && (React.createElement("div", null,
            React.createElement(Styles.VehicleCardPriceMonthly, { as: "p", weight: "400" }, truncatedZeroPencePrice(priceMonthly)),
            React.createElement(Styles.VehicleCardPriceText, { as: "p" }, "Monthly payment"))),
        priceUpfront && (React.createElement("div", null,
            React.createElement(Styles.VehicleCardPriceUpfront, { as: "p" }, truncatedZeroPencePrice(priceUpfront)),
            React.createElement(Styles.VehicleCardPriceText, { as: "p" }, "Initial payment")))));
};
